import React from 'react'
import { DropdownMenu, Dropdown, DropdownToggle } from 'reactstrap';
export default (props) => {
  return (
    <div className="align-self-end d-flex justify-content-center align-items-center">
      {props.options.map(option => {
        switch (option.type) {
          case "dropdown":
            return (
              <div key={option.name} className="d-flex justify-content-center align-items-center ml-4 filter-item">
                <div className="text-muted">{option.title}</div>
                <Dropdown isOpen={option.isOpen} toggle={option.toggle} className="nav-item" >
                  <DropdownToggle nav>
                    <div className="d-flex justify-content-between align-items-center">
                      <div className="font-weight-bold small">{option.items[option.selectedIndex].name}</div>
                      <div className="angle-down s7-angle-down filter-item__icon"></div>
                    </div>
                  </DropdownToggle>
                  <DropdownMenu>
                    {option.items.map((item, index) => {
                      return <div key={`${option.name}-${index}`} className={'dropdown-item hover'} onClick={() => item.onSelect(index)}>{item.name}</div>
                    })}
                  </DropdownMenu>
                </Dropdown>
              </div>
            )
          default: return null
        }
      })}
    </div>
  )
}


// WEBPACK FOOTER //
// ./src/components/FilterSorter.js